import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-526e291f")

_pushScopeId("data-v-526e291f")
const _hoisted_1 = { class: "font-size15px" }
const _hoisted_2 = { class: "font-size15px" }
const _hoisted_3 = { class: "font-size15px" }
const _hoisted_4 = { class: "shell margin-top10px full-container list-overflow" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_user = _resolveComponent("user")
  const _component_device = _resolveComponent("device")
  const _component_third_party_devices = _resolveComponent("third-party-devices")
  const _component_user_info = _resolveComponent("user-info")
  const _component_office_people_info = _resolveComponent("office-people-info")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.buildType!='public')
      ? (_openBlock(), _createBlock(_component_cus_button, {
          key: 0,
          type: _ctx.contentType == 'user' || _ctx.contentType == 'userinfo' || _ctx.contentType == 'automation' ?'blue':'default',
          class: "button-padding",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeType('user')))
        }, {
          default: _withId(() => [
            _createVNode("label", _hoisted_1, _toDisplayString(_ctx.buildType == (_ctx.isOffice ? 'all' : 'community') ? _ctx.ChangeWordList.PeopleDevicePeople :
                    _ctx.ChangeWordList.PeopleDeviceDepartmentPeople), 1)
          ]),
          _: 1
        }, 8, ["type"]))
      : _createCommentVNode("", true),
    _createVNode(_component_cus_button, {
      class: "button-padding margin-left10px",
      type: _ctx.contentType == 'device'?'blue':'default',
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeType('device')))
    }, {
      default: _withId(() => [
        _createVNode("label", _hoisted_2, _toDisplayString(_ctx.isOffice?
                    (_ctx.buildType =='all'?_ctx.$wordList.OrderDevice:_ctx.$wordList.RDeivicePublicDevice):
                    _ctx.$wordList.IntercomDevices), 1)
      ]),
      _: 1
    }, 8, ["type"]),
    (_ctx.isShowThirdDevice)
      ? (_openBlock(), _createBlock(_component_cus_button, {
          key: 1,
          class: "button-padding margin-left10px",
          type: _ctx.contentType == 'thirdPartyDevices'?'blue':'default',
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeType('thirdPartyDevices')))
        }, {
          default: _withId(() => [
            _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$wordList.ThirdPartyDevices), 1)
          ]),
          _: 1
        }, 8, ["type"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_4, [
      (_ctx.contentType === 'user')
        ? (_openBlock(), _createBlock(_component_user, {
            key: 0,
            build: _ctx.isOffice ? _ctx.DepartmentID : _ctx.build
          }, null, 8, ["build"]))
        : _createCommentVNode("", true),
      (_ctx.contentType === 'device')
        ? (_openBlock(), _createBlock(_component_device, { key: 1 }))
        : _createCommentVNode("", true),
      (_ctx.contentType === 'thirdPartyDevices')
        ? (_openBlock(), _createBlock(_component_third_party_devices, {
            key: 2,
            build: _ctx.buildType,
            "device-type": _ctx.deviceType
          }, null, 8, ["build", "device-type"]))
        : _createCommentVNode("", true),
      (_ctx.contentType === 'userinfo' && !_ctx.isOffice)
        ? (_openBlock(), _createBlock(_component_user_info, { key: 3 }))
        : _createCommentVNode("", true),
      (_ctx.contentType === 'userinfo' && _ctx.isOffice)
        ? (_openBlock(), _createBlock(_component_office_people_info, { key: 4 }))
        : _createCommentVNode("", true)
    ])
  ]))
})